/*
 * Which processing pipeline the connected system runs. Pipeline 2.0 calibrates
 * itself, so the UI hides every calibration control; 1.0 still needs a
 * clinician to record a calibration and pick one per trial.
 */
export const PIPELINE_VERSION_1 = '1.0';
export const PIPELINE_VERSION_2 = '2.0';

/** New installs are 2.0; only sites still on the old pipeline opt back to 1.0. */
export const DEFAULT_PIPELINE_VERSION = PIPELINE_VERSION_2;

export const PIPELINE_VERSIONS = [PIPELINE_VERSION_1, PIPELINE_VERSION_2];

export const PIPELINE_VERSION_KEY = 'pipelineVersion';

/** Mirrors the evoWalkToggle event so open pages re-render without a reload. */
export const PIPELINE_VERSION_EVENT = 'pipelineVersionChange';

export function getPipelineVersion() {
  const stored = localStorage.getItem(PIPELINE_VERSION_KEY);
  return PIPELINE_VERSIONS.includes(stored) ? stored : DEFAULT_PIPELINE_VERSION;
}

export function setPipelineVersion(version) {
  const next = PIPELINE_VERSIONS.includes(version) ? version : DEFAULT_PIPELINE_VERSION;
  localStorage.setItem(PIPELINE_VERSION_KEY, next);
  window.dispatchEvent(new Event(PIPELINE_VERSION_EVENT));
  return next;
}

export function isCalibrationUiEnabled(version = getPipelineVersion()) {
  return version === PIPELINE_VERSION_1;
}
